export { Heading1, Heading2, Heading3, Heading4, Heading5, Heading6 } from "./Heading.styles";
